import type { BreadcrumbsType, IndustryUrlParam } from '@/routes/Router';
import type { match } from 'react-router-dom';
import { IntlShape } from 'react-intl';

export type Crumb = BreadcrumbsType;

type CrumbFunction = ({
  routes,
  match,
  intl,
}: {
  routes: BreadcrumbsType[];
  match: match<IndustryUrlParam>;
  intl: IntlShape;
}) => Crumb[];

const getCrumbs: CrumbFunction = ({ routes, match, intl }) => {
  const crumbs = routes
    .filter(({ path }) => {
      const regexp = new RegExp(`^${path}`);
      return regexp.test(match.path);
    })
    .map(({ path, name, ...rest }) => ({
      path: Object.keys(match.params).length
        ? Object.keys(match.params).reduce(
            (path, param) =>
              path.replace(
                `:${param}`,
                match.params[param as keyof IndustryUrlParam],
              ),
            path,
          )
        : path,
      name:
        typeof name === 'function'
          ? name(match.params)
          : intl.formatMessage({ id: name }),
      ...rest,
    }));
  return crumbs;
};

export { getCrumbs };
